<template>
	<div>
		<div v-show="isFirst">
			<div style="margin-top: 20px;">
				<el-row  :gutter="12" style="margin-right: 0!important;">
					<el-col :span="8">
						<el-select v-model="statusSelect" @change="statusChange" style="width: 110px;">
							<el-option label="全部状态" value="-1"></el-option>
							<el-option label="失败" value="103"></el-option>
							<el-option label="已付款" value="106"></el-option>
							<el-option label="已发货" value="107"></el-option>
						</el-select>
					</el-col>
					<el-col :span="16">
						<div style="width: 100%;text-align: right;">
							<el-select style="width: 110px;margin-left: 3px;" v-model="selectValue" placeholder="请选择">
								<el-option label="收件人" value="1"></el-option>
								<el-option label="电话" value="2"></el-option>
								<el-option label="订单号" value="3"></el-option>

								<el-option label="开单日期" value="5"></el-option>
							</el-select>
							<el-input type="text" style="width:255px;margin-left: 3px;" v-model="queryValue" v-if="isInput" placeholder="请输入"></el-input>
							<el-date-picker
											style="width: 255px;margin-left: 3px;"
											v-if="!isInput"
											v-model="time"
											type="daterange"
											range-separator="至"
											start-placeholder="订单开始日期"
											end-placeholder="订单结束日期"
											format="yyyy-MM-dd">
							</el-date-picker>
							<el-button type="primary" style="margin-left: 3px;" icon="el-icon-search" @click="updateTable">搜索</el-button>
						</div>
					</el-col>

				</el-row>
			</div>
			<div style="margin-top: 10px;">
				<el-table ref="multipleTable" 
				 :data="tableData" 
				 style="width: 100%" 
				 element-loading-text="数据正在加载中" 
				 @selection-change="handleSelectionChange"
			 	 :row-style="rowClass">
			      <el-table-column type="selection" width="60"></el-table-column>
			      <el-table-column prop="orderId" label="订单号" sortable></el-table-column>
			      <el-table-column prop="nickname" label="买家" ></el-table-column>
			      <el-table-column label="状态" >
			      	<template slot-scope="scope">
			      		<div>
			      			<span v-if="scope.row.status == 101">已创建</span>
			      			<span v-if="scope.row.status == 102">已取消</span>
			      			<span v-if="scope.row.status == 103">失败</span>
			      			<span v-if="scope.row.status == 104">异常</span>
									<span v-if="scope.row.status == 105">未付款</span>
									<span v-if="scope.row.status == 106">已付款</span>
									<span v-if="scope.row.status == 107">已发货</span>
									<span v-if="scope.row.status == 108">已收货</span>
									<span v-if="scope.row.status == 109">已完成</span>
			      		</div>
			      	</template>
			      </el-table-column>
			      <el-table-column prop="deliveryInfo.receiver" label="收件人"></el-table-column>
			      <el-table-column prop="deliveryInfo.tel" label="电话"></el-table-column>
			      <el-table-column prop="deliveryInfo.address" label="地址"></el-table-column>
			      <el-table-column prop="payInfoRO.posttime" label="购买时间" :formatter="dateFormat"></el-table-column>
			      <el-table-column label="操作">
			      	<template slot-scope="scope">
			      		<button @click="getMessage(scope.row)">详情</button>
			      	</template>
			      </el-table-column>
			    </el-table>
			    <el-pagination background
		    			style="text-align:right;margin-top: 15px;margin-bottom: 65px;"
			            @size-change="handleSizeChange"
			            @current-change="handleCurrentChange"
			            :current-page="currentPage"
			            :page-sizes="[10, 50, 100, 200]"
			            :page-size="pageSize" 
			            layout="total, sizes, prev, pager, next, jumper"
			            :total="total">
			    </el-pagination>
			</div>
		</div>
		<div v-if="!isFirst">
			<div style="margin-top: 20px;">
				<i class="el-icon-back" style="font-size: 16px;cursor:pointer;" @click="isFirst = true">详情</i>
			</div>
			<el-row>
				<el-col :span="18">
					<table style="border-collapse:separate; border-spacing:0px 10px;margin-top: 25px;">
						<tr>
							<td>订单号</td>
							<td class="tdClassForAccount">{{tempData.orderId}}</td>
						</tr>
						<tr>
							<td>收件人</td>
							<td class="tdClassForAccount">{{tempData.deliveryInfo.receiver}}</td>
						</tr>
						<tr>
							<td>电话</td>
							<td class="tdClassForAccount">{{tempData.deliveryInfo ? tempData.deliveryInfo.tel : ''}}</td>
						</tr>
						<tr>
							<td>地址</td>
							<td class="tdClassForAccount">
								<div>{{tempData.deliveryInfo ? tempData.deliveryInfo.address : ''}}</div>
							</td>
						</tr>
					</table>
				</el-col>
				<el-col :span="6">
					<div style="margin-top: 50px;">
						<el-button v-if="tempData.status == 106&&isBrand" @click="myDialog = true">发货</el-button>
						<div v-else>
								<span v-if="tempData.status == 101">已创建</span>
								<span v-if="tempData.status == 102">已取消</span>
								<span v-if="tempData.status == 103">失败</span>
								<span v-if="tempData.status == 104">异常</span>
								<span v-if="tempData.status == 105">未付款</span>
								<span v-if="tempData.status == 106">已付款</span>
								<span v-if="tempData.status == 107">已发货</span>
								<span v-if="tempData.status == 108">已收货</span>
								<span v-if="tempData.status == 109">已完成</span>
                                <span v-if="tempData.status == 110">已退款</span>
						</div>
					</div>
				</el-col>
			</el-row>
			<el-table ref="returnTable"
								key="returnTable"
								:data="[tempData]"
								style="width: 100%"
								@selection-change="returnTableChange"
								element-loading-text="数据正在加载中"
								:row-style="rowClass">
				<el-table-column type="orderId" width="60"></el-table-column>
				<el-table-column prop="orderId" label="商品名称"></el-table-column>
				<el-table-column label="图片">
					<template slot-scope="scope">
						<div>
							<img :src="scope.row.merchInfoRO.image" style="width: 30px;height: 30px;"/>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="merchInfoRO.uprice" label="金额"></el-table-column>
				<el-table-column prop="merchInfoRO.quanlity" label="数量"></el-table-column>
				<el-table-column label="属性">
					<template slot-scope="scope">
						{{scope.row.merchInfoRO.propertiesName.split(';').join('\n')}}
					</template>
				</el-table-column>
			</el-table>
		</div>
		<el-dialog :visible.sync="myDialog" width="460px" title="添加设备序列号">
			<el-tabs v-model="activeName">
				<el-tab-pane label="手动输入sn" name="first">
					<div>
						<el-input
										type="textarea"
										style="width: 420px"
										:rows="7"
										placeholder="请输入设备出厂的条码号,多个条码号请用英文,分隔"
										v-model="snValue">
						</el-input>
					</div>
					<div style="margin-top: 10px;text-align: right;width: 95%;">
						<el-button :loading="loadingForSend" @click="sendProduct" type="primary">确认发货</el-button>
					</div>
				</el-tab-pane>
			</el-tabs>
		</el-dialog>
	</div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'buyOut',
  components: {
  },
  data() {
    return {
    	addressList:[],
			tempData: {},
    	commodityProps:{
    		value:'label',
    		label:'label'
    	},
			statusSelect: "-1",
    	accountNewForm:{
    		selectList:[],
    		address:'',
    		customerName:'',
    		contact:'',
    		contactNumber:''
    	},
    	total: 0,
        currentPage: 1,
　　  	pageSize: 10,
		tableData:[],
		multipleSelection:[],
		myDialog:false,
		uploadData:{
			id:""
		},
		isFirst:true,
		typeSelect:"0",
		selectValue:"",
		queryValue:"",
		time:[],
		isAgent:false,
		isBrand:false,
		title:"新建开单",
		isNew:true,
		customerName:"",
		id:"",
		address:"",
		city:"",
		contact:"",
		contactNumber:"",
		district:"",
		province:"",
		list:[],
		productList:[],
		status:"",
		isNeedConfirm:true,
		isSend:true,
		snValue:'',
		isReturn:false,
		returnList:[],
		returnSelection:[],
		myDialog2:false,
		returnReason:"",
        activeName:'first',
        loadingForSend:false,
		uploadExcel:this.$store.getters.getApiValue+"/application/shipByExcel.do",
		downloadHref:this.$store.getters.getApiValue+"/UploadTemplate.xls"
    }
  },
  watch: {
  },
  computed:{
  	isInput:function(){
  		if(this.selectValue != "5"){
  			this.queryValue = "";
  			return true;
  		}else{
  			return false;
  		}
  	}
  },
  mounted() {
    var thiz = this;
	axios.get(this.$store.getters.getApiValue+'/srsUser/getMyData.do').then(function (response) {
			var data = response.data;
			if(data.status == "200"){
				if(data.data.role == "2" || data.data.role == "3"||data.data.role == "8"||data.data.role == "9"){
					thiz.isAgent = true;
				}else if(data.data.role == "4"){
					thiz.isBrand = true;
				}
			}else{
				thiz.$message.error(data.message);
			}
		}).catch(function (error) {
			thiz.$message.error("系统异常，请与管理员联系!");
			console.log(error);
		});
  	this.updateTable();
  },
  beforeDestroy() {
  },
  methods: {
		rowClass({ row, rowIndex}) {
			if(rowIndex%2 == 0){
				return 'background:#F1F2F7;'
			}else{
				return 'background:white;'
			}
			return ''
		},
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		returnTableChange(val) {
			this.returnSelection = val;
		},
		handleSizeChange(val) {
			this.pageSize = val;
			this.updateTable();
		},
		handleCurrentChange(val) {
			this.currentPage = val;
			this.updateTable();
		},
		statusChange() {
			this.updateTable();
		},
		updateTable() {
			var params = {
				status: this.statusSelect,
				pageId: this.currentPage,
				size: this.pageSize,
				type: 5
			};
			if (this.typeSelect != "0") {
				params.type = this.typeSelect
			}
			if (this.selectValue == "1" && this.queryValue != "") {
				params.receiver = this.queryValue;
			} else if (this.selectValue == "2" && this.queryValue != "") {
				params.tel = this.queryValue;
			} else if (this.selectValue == "3" && this.queryValue != "") {
				params.orderId = this.queryValue;
			} else if (this.selectValue == "5") {
				if (this.time != null && this.time.length > 0) {
					params.startDate = this.getStandardDate(this.time[0]);
					params.endDate = this.getStandardDate(this.time[1]);
				}
			}
			const loading = this.$loading({
				lock: true,
				text: '获取表格数据中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			setTimeout(() => {
				loading.close();
			}, 3000);
			var thiz = this;
			axios.get(this.$store.getters.getApiValue + '/order/searche.do', {
				params: params
			}).then(function(response) {
				loading.close();
				var data = response.data;
				if (data.status == "200") {
					thiz.total = data.totalCount;
					thiz.tableData = data.data;
				} else {
					thiz.$message.error(data.message);
				}
			}).catch(function(error) {
				loading.close();
				thiz.$message.error("系统异常，请与管理员联系!");
				console.log(error);
			});
		},
		getMessage(row) {
			this.tempData = row
			this.isFirst = false
		},
		dateFormat(row, column, cellValue, index) {
			var str = cellValue;
			if (str == null || str == "") {
				return "";
			} else {
				return this.getStandardDate(new Date(str));
			}
		},
		getStandardDate(val){
			var year = val.getFullYear();
			var month = val.getMonth() + 1;
			var day = val.getDate();
			month = month < 10 ? "0"+month : month;
			day = day < 10 ? "0"+day : day;
			return year+"-"+month+"-"+day;
		},
		sendProduct() {
			const params = {
				orderId: this.tempData.orderId,
				express: '',
				expressNum: '',
				sn: this.snValue
			}
			if(this.snValue === '') {
				this.$message.error("请输入单号，并用逗号隔开")
				return
            }
            this.loadingForSend=true;
			axios.get(this.$store.getters.getApiValue + '/order/delivery.do', {
				params: params
			}).then(({data}) => {
				if(data.status === '200') {
					this.myDialog = false
					this.tempData.status = "107"
          this.$message.success('发货成功')
				} else {
					this.$message.error(data.message);
				}
			}).catch((error) => {
				this.$message.error("系统异常，请与管理员联系!");
				console.log(error);
			}).finally(() => {
		    	this.loadingForSend = false;
			});
		}
	}
}
</script>

<style>
  .el-table{
  	font-size: 12px;
  	border-bottom: 1px solid #dcd8d8;
  	color: black;
  }
  .el-table tr th{
  	border-top: 0px;
  	border-left: 0px;
  	border-right: 0px;
  }
  .el-table tr td{
  	border-bottom: 1px solid #dcd8d8;
  }
  .tdClassForAccount{
  	padding-left: 10px;
  }
  .imgDiv .commodityImg{
		width: 120px;
		height: 120px;
	}
</style>